import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'calcSvgXPosition',
    standalone: false
})
export class CalcSvgXPositionPipe implements PipeTransform {
  transform(
    x: number,
    flip: boolean,
    { width, height }: { width: number; height: number },
    circle = false
  ): unknown {
    if (x < 0) {
      return (
        1500 * (1 + x / 150) - ((circle ? 0 : 1) * (flip ? height : width)) / 2
      );
    }
    return (
      1500 + 1500 * (x / 150) - ((circle ? 0 : 1) * (flip ? height : width)) / 2
    );
  }
}
